import './App.css';
import AppHeader from './AppHeader'
import {Routes, Route, useLocation} from "react-router-dom";
import Home from "./pages/Home.jsx";
import Login from './pages/admin/Login';
import Register from './pages/Register.jsx';
import MyProfile from './pages/MyProfile.jsx';
import PrivacyPolicy from './pages/PrivacyPolicy.jsx';
import Organizers from './pages/Organizers.jsx';
import { AddCompetition } from './pages/AddCompetition.jsx';
import { EditCompetition } from './pages/EditCompetition.jsx';
import Results from './pages/Results.jsx';
import Stats from './pages/Stats.jsx';
import CoursesStats from './pages/CoursesStats.jsx';
import Competitions from './pages/Competitions.jsx';
import MyCompetition from './pages/MyCompetition.jsx';
import ScoreEntry from './pages/ScoreEntry.jsx';
import RoundStage from './pages/RoundStage.jsx';
import AuditLogs from './pages/AuditLogs.jsx';
import { RenewPWD } from './pages/admin/RenewPWD';
import NotFound from './pages/NotFound.jsx';
import Navbar from './components/Navbar';
import InstallAppPrompt from './components/InstallAppPrompt';
import "react-toastify/dist/ReactToastify.css";

function App() {
  const location = useLocation();
  const hideNavbar = location.pathname.startsWith('/kirjaus');

  console.log("Locked Status:", process.env.REACT_APP_SPOT_STATUS_LOCKED);

  return (
    <div className='min-h-screen overflow-x-hidden'>
      <InstallAppPrompt />
            
      {/*<Header></Header>*/}
      {!hideNavbar && <Navbar></Navbar>} 
         
      {/* <div className="pt-16"> */}
        
      <Routes>            
              {/* Pubblic routes */}
              <Route element={<AppHeader/>}>
                {/* <Route path='/' element={<DiscGolfCircle/>}></Route> */}
                <Route path='/' element={<Home/>}></Route>                   
                <Route path="/login" element={<Login/>}></Route> 
                <Route path="/register" element={<Register/>}></Route> 
                <Route path="/tulokset" element={<Results/>}></Route>
                <Route path="/tulokset/:competitionID" element={<Results/>}></Route>
                <Route path="/tilastot" element={<Stats/>}></Route>
                <Route path="/radat" element={<CoursesStats/>}></Route>
                <Route path="/tietosuojaseloste" element={<PrivacyPolicy/>}></Route>
                <Route path="/kisat" element={<Competitions/>}></Route>
                <Route path="/kisat/:competitionID" element={<Competitions/>}></Route>
                <Route path="/jarjestajat" element={<Organizers/>}></Route>
                <Route path="/omat-pelit" element={<MyCompetition/>}></Route>
                <Route path="/audit-logs" element={<AuditLogs/>}></Route>
                <Route path="/kirjaus/:competitionID/:pairID" element={<ScoreEntry/>}></Route>
                <Route path="/stage" element={<RoundStage/>}></Route>
                <Route path="/profiili" element={<MyProfile/>}></Route>
                <Route path="/lisaa_kisa" element={<AddCompetition/>}></Route>
                <Route path="/muokkaa_kisa/:competitionID" element={<EditCompetition/>}></Route>
                <Route path="/uusi-salasana" element={<RenewPWD/>}></Route> 

                <Route path="*" element={<NotFound/>}></Route>
              </Route>
                              
              {/*
              <Route element={<LogoLayout/>}>
                
              </Route>
                  

              {/* protected routes }          
              <Route element={<RequireAuth/>}>
                <Route path="/admin" element={<LogoLayout/>}>
                  <Route path="/admin" element={<AdminHome/>}></Route> 
                  <Route path="/admin/lahjoitukset" element={<Payments/>}></Route> 
                  <Route path="/admin/pyynnot" element={<Orders/>}></Route>

                </Route>
              </Route>
              */}
            </Routes>
          {/* </div> */}
    </div>
  );
}

export default App;
